import { render, staticRenderFns } from "./CorrectiveActionRequestForm.vue?vue&type=template&id=add264f8"
import script from "./CorrectiveActionRequestForm.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports